// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export const fetchEmployerFilteredVenuesList = employerID => {
  return { type: types.EMPLOYER_VENUES_FILTERED_FETCH_BEGIN, employerID }
}
